module.exports = __webpack_public_path__ + "img/melanoma-uk-logo.20735ec8.png";